var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "question-display",
      attrs: {
        "aria-label": "Question",
        id: "question-" + _vm.activeQuestion.TEST_QUESTION_RID
      }
    },
    [
      _c("div", { staticClass: "sr-only" }, [
        _c("p", [
          _vm._v(
            "\n\t\t\t\t\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.testTaker.questionNumber", {
                  number: _vm.activeQuestion.index + 1
                })
              ) +
              "\n\t\t\t\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pull-right" }, [
        _c("span", { staticClass: "pill pill-dark" }, [
          _vm._v(
            "\n\t\t\t\t\t\t\t" +
              _vm._s(
                _vm.$t("MAIN_CONTENT.MatchingQuestion.pointsPossible", {
                  points: _vm.activeQuestion.TOTAL_POINTS
                })
              ) +
              "\n\t\t\t\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "question-type-instructions" }, [
        _c("strong", [_vm._v(_vm._s(_vm.activeQuestion.QUESTION_NAME))]),
        _vm._v(" "),
        _c("span", { staticClass: "hint" }, [
          _vm._v(
            "\n\t\t\t\t\t\t\t" +
              _vm._s(_vm.$t("MAIN_CONTENT.MatchingQuestion.instruction")) +
              "\n\t\t\t\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isGraded(_vm.activeQuestion)
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "answers" },
                _vm._l(_vm.subQuestionMatches, function(subQ) {
                  return _c(
                    "div",
                    {
                      key: subQ.TEST_QUESTION_RID,
                      class: _vm.getAnswerClass(subQ.ANS_CORRECT_FLG)
                    },
                    [
                      _c("div", { staticClass: "answer-number selected" }, [
                        _c("i", {
                          staticClass: "fa fas fa-arrow-circle-right"
                        }),
                        _vm._v(" "),
                        subQ.ANS_CORRECT_FLG
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "badge badge-dark answer-points float-right",
                                attrs: { "aria-label": "Points Earned" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("MAIN_CONTENT.testTaker.points", {
                                        points: subQ.POINTS_EARNED.toFixed(2)
                                      })
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "question-text",
                        domProps: {
                          innerHTML: _vm._s(_vm.getAnswerText(subQ.ANSWER_RID))
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "answer-text",
                        domProps: { innerHTML: _vm._s(subQ.QUESTION_TEXT) }
                      }),
                      _vm._v(" "),
                      !subQ.ANS_CORRECT_FLG && _vm.testMode == "grading"
                        ? _c("div", { staticClass: "question-text" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.MatchingQuestion.correctAnswer"
                                  )
                                ) +
                                "\n                        "
                            ),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getCorrectAnswerText(subQ.QUESTION_TEXT)
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "grade-result" }, [
                        _c("i", {
                          class: _vm.getFeedbackIcon(subQ.ANS_CORRECT_FLG)
                        })
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("question-summary")
            ],
            1
          )
        : _c("div", [
            _c("div", { staticClass: "question-type-instructions" }, [
              _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t\t\t\t\t" +
                    _vm._s(
                      _vm.$t("MAIN_CONTENT.MatchingQuestion.instruction")
                    ) +
                    "\n\t\t\t\t\t\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c("h3", {
              staticClass: "question-text",
              domProps: { innerHTML: _vm._s(_vm.activeQuestion.QUESTION_TEXT) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "matching-pairs answer row" }, [
              _c(
                "div",
                { staticClass: "col-sm-6 answers" },
                _vm._l(_vm.subQuestions, function(prompt, i) {
                  return _c(
                    "div",
                    {
                      key: prompt.TEST_QUESTION_RID,
                      staticClass: "matching-prompt form-inline clearfix"
                    },
                    [
                      _c("div", { staticClass: "col-sm-2" }, [
                        _c(
                          "select",
                          {
                            ref: "answerRef-" + i,
                            refInFor: true,
                            staticClass: "form-control",
                            on: {
                              change: function($event) {
                                return _vm.answerTheQuestion($event, i)
                              }
                            }
                          },
                          [
                            _vm.workingAnswers[i].ANSWER_RID === ""
                              ? _c("option", { attrs: { selected: "true" } })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.promptAnswers, function(itm, j) {
                              return _c(
                                "option",
                                {
                                  key: j,
                                  attrs: {
                                    "aria-label": itm.TEST_QUESTION_ANSWER_TEXT
                                  },
                                  domProps: {
                                    value: j,
                                    selected:
                                      itm.ANSWER_RID ===
                                      _vm.workingAnswers[i].ANSWER_RID
                                        ? true
                                        : false
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.getAnswerChoice(j)) +
                                      "\n                                "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "col-sm-10",
                        domProps: { innerHTML: _vm._s(prompt.QUESTION_TEXT) }
                      })
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "answers col-xs-6" },
                _vm._l(_vm.promptAnswers, function(answer, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "clickable answer" },
                    [
                      _c("div", { staticClass: "answer-number" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.getAnswerChoice(index)) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "answer-text",
                        domProps: { innerHTML: _vm._s(answer.ANSWER_TEXT) }
                      })
                    ]
                  )
                }),
                0
              )
            ])
          ]),
      _vm._v(" "),
      _vm.testMode !== "grading"
        ? _c("test-buttons", { on: { "answer-save": _vm.submitAnswer } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }